// StudentDocNotes.jsx

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import Beatloader from '../../../../Common/BeatLoader'
import ResponsivePagination from '../../../../Common/Pagination'
import { getStudentStudyMaterialDocListData } from '../../../../Redux/action/StudentAction'

const host = process.env.REACT_APP_API_SERVER

const StudentDocNotes = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getStudentStudyMaterialDocListData())
    }, []);

    const {
        loadingStudentStudyMaterialDocListApi,
        StudentStudyMaterialDocListApiData,
    } = useSelector(state => state?.StudentReducer);

    console.log("DOC REDUX DATA =>", StudentStudyMaterialDocListApiData);

    const handleDocClick = (materialFile) => {
        if (!materialFile) return;

        const pathParts = materialFile.split('/');
        const fileName = pathParts.pop();
        const encodedFileName = encodeURIComponent(fileName);
        const encodedPath = `${host}${pathParts.join('/')}/${encodedFileName}`;

        window.open(encodedPath, "_blank", "noopener,noreferrer");
    };

    // pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const dataPerPage = 10;

    useEffect(() => {

        if (!StudentStudyMaterialDocListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(StudentStudyMaterialDocListApiData.slice(start, end));
        setPageCount(Math.ceil(StudentStudyMaterialDocListApiData.length / dataPerPage));

    }, [currentPage, StudentStudyMaterialDocListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>

            <section className="after-header">

                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">

                        <li className="breadcrumb-item ps-5" aria-current="page">

                            <button
                                onClick={() => window.history.back()}
                                style={{ border: "none", background: "none" }}
                            >
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </button>

                            &nbsp;&nbsp;DOC Notes

                        </li>

                    </ol>
                </nav>

                <div className="main-container-sec">

                    <div className="row mx-0">

                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>

                        <div className="col-lg-9">

                            <main className="px-3 py-4">

                                <div className="my-student-sec">

                                    {loadingStudentStudyMaterialDocListApi ?

                                        <Beatloader />

                                        :

                                        <div className="row">

                                            {StudentStudyMaterialDocListApiData?.length > 0 ?

                                                currentData?.map((data) => (

                                                    <div
                                                        className="col-lg-6 mt-3 col-md-6"
                                                        key={data?.id}
                                                        onClick={() => handleDocClick(data?.material_file)}
                                                    >

                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{
                                                                backgroundColor: "aliceblue",
                                                                cursor: "pointer"
                                                            }}
                                                        >

                                                            <div className="card-body">

                                                                <div className="row gap-0">

                                                                    <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">

                                                                        <img
                                                                            src="https://cdn-icons-png.flaticon.com/512/281/281760.png"
                                                                            className="img-fluid"
                                                                            style={{
                                                                                height: 85,
                                                                                width: "auto",
                                                                                borderRadius: 15
                                                                            }}
                                                                        />

                                                                    </div>

                                                                    <div className="col-lg-8 m-0 p-0 d-flex flex-column text-start justify-content-center col-md-8 col-sm-8">

                                                                        <h5 className="mb-0 text-dark">
                                                                            {data?.study_material?.material_name}
                                                                        </h5>

                                                                        <p className="mb-0">
                                                                            {new Date(data?.createdAt).toDateString()}
                                                                        </p>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                ))

                                                :

                                                <div className='no-data-img text-center'>

                                                    <img
                                                        width={100}
                                                        src="/assets/img/user/no-data.png"
                                                        alt=""
                                                    />

                                                </div>

                                            }

                                        </div>

                                    }

                                    {pageCount > 1 && (
                                        <ResponsivePagination
                                            pageCount={pageCount}
                                            currentPage={currentPage}
                                            handlePageClick={handlePageClick}
                                        />
                                    )}

                                </div>

                            </main>

                        </div>

                    </div>

                </div>

            </section>

        </div>
    )
}

export default StudentDocNotes